const FALLBACK_COUNTRY_NAMES: Record<string, string> = {
  KE: 'Kenya',
  UG: 'Uganda',
}

/** 解析当前国家展示名（优先 regions 列表，其次 regionCode 映射） */
export const resolveCurrentCountryName = (): string => {
  const regions = useCountrys().value
  const regionId = Number(useCurrentCountry().value)
  const fromList = regions.find((c: region.IRegionItem) => c.id === regionId)?.name

  if (fromList) {
    return fromList
  }

  const code = (useCurrentCountryCode().value || 'KE').toUpperCase()
  return FALLBACK_COUNTRY_NAMES[code] || FALLBACK_COUNTRY_NAMES.KE
}

export const getDefaultSiteTitle = (countryName?: string) =>
  `Kilimall - Affordable Online Shopping in ${countryName || resolveCurrentCountryName()}`
